// Minimal Mozambique locations data for selects
// Structure: { [provincia]: { [distrito]: string[] (localidades) } }

export const provincesData = {
  'Maputo': {
    'Maputo Cidade': [],
    'Matola': [],
    'Boane': [],
    'Marracuene': [],
  },
  'Gaza': {
    'Xai-Xai': [],
    'Chokwe': [],
    'Chibuto': [],
  },
  'Inhambane': {
    'Inhambane': [],
    'Maxixe': [],
    'Vilankulo': [],
  },
  'Sofala': {
    'Beira': [],
    'Dondo': [],
    'Buzi': [],
  },
  'Manica': {
    'Chimoio': [],
    'Gondola': [],
  },
  'Tete': {
    'Tete': [],
    'Moatize': [],
  },
  'Zambezia': {
    'Quelimane': [],
    'Mocuba': [],
  },
  'Nampula': {
    'Nampula': [],
    'Nacala': [],
  },
  'Niassa': {
    'Lichinga': [],
  },
  'Cabo Delgado': {
    'Pemba': [],
    'Montepuez': [],
  },
}

